var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center"},[_c('photo-viewer',{attrs:{"photoFn":_vm.getPhotosFn(_vm.params)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }